import React, { useState } from "react";
import axios from "axios";
import API_URL from "./config";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [isError, setIsError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    setIsError(false);
    if (!validateEmail(email)) {
      setStatus("Please enter a valid email address.");
      setIsError(true);
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API_URL}/api/newsletter`, { email });
      setStatus(res.data.message);
      setIsError(false);
      setEmail("");
    } catch (err) {
      setStatus(
        err.response?.data?.error ||
        "Subscription failed, please try again."
      );
      setIsError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative max-w-lg mx-auto">
      {status && (
        <div
          className={`w-full mb-8 transition-all duration-700 ease-out animate-fade-in ${
            isError
              ? "text-center"
              : "text-center"
          }`}
        >
          {/* Editorial-style message container */}
          <div className="relative">
            {/* Decorative line above */}
            <div className={`w-24 h-px mx-auto mb-6 ${
              isError 
                ? 'bg-gradient-to-r from-transparent via-red-300 to-transparent' 
                : 'bg-gradient-to-r from-transparent via-white/40 to-transparent'
            }`}></div>
            
            {/* Message text */}
            <p className={`text-sm font-light tracking-[0.15em] uppercase leading-relaxed ${
              isError 
                ? 'text-red-300' 
                : 'text-white/80'
            }`}>
              {status}
            </p>
            
            {/* Decorative line below */}
            <div className={`w-24 h-px mx-auto mt-6 ${
              isError 
                ? 'bg-gradient-to-r from-transparent via-red-300 to-transparent' 
                : 'bg-gradient-to-r from-transparent via-white/40 to-transparent'
            }`}></div>
            
            {/* Editorial accent mark for errors */}
            {isError && (
              <div className="absolute -left-8 top-1/2 transform -translate-y-1/2 text-red-300/40 text-2xl font-thin">
                "
              </div>
            )}
            {isError && (
              <div className="absolute -right-8 top-1/2 transform -translate-y-1/2 text-red-300/40 text-2xl font-thin">
                "
              </div>
            )}
          </div>
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Your email address"
          className="flex-1 bg-transparent border-b border-white/30 px-0 py-4 text-white placeholder-white/50 focus:border-white focus:outline-none font-light text-sm tracking-wide transition-all duration-300 hover:border-white/50"
          disabled={submitting}
        />
        <button
          type="submit"
          disabled={submitting}
          className="border border-white/40 px-8 py-4 text-xs tracking-[0.2em] uppercase font-light hover:bg-white hover:text-black hover:border-white transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed hover:tracking-[0.25em]"
        >
          {submitting ? "Subscribing..." : "Subscribe"}
        </button>
      </form>
      
      {/* Editorial-style CSS animations */}
      <style>{`
        .animate-fade-in {
          animation: editorial-fade-in 0.8s ease-out;
        }
        @keyframes editorial-fade-in {
          from { 
            opacity: 0; 
            transform: translateY(-12px) scale(0.98);
          }
          to { 
            opacity: 1; 
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default NewsletterSignup;